/** Reports application API — navegación, use cases, screen constants y utils. */

export type { ReportsNavigationIntent } from './application/reportsNavigationIntent';
export {
  consumeReportsNavigationIntent,
  setReportsNavigationIntent,
} from './application/reportsNavigationIntent';

export {
  loadReportsOperacionDashboard,
  loadReportsOperacionRentabilidad,
  loadReportsOperacionRentabilidadKpis,
  type LoadReportsOperacionDashboardParams,
  type LoadReportsOperacionDashboardResult,
  type LoadReportsOperacionRentabilidadParams,
  type LoadReportsOperacionRentabilidadResult,
} from './application/reportsOperacionDashboard';

export {
  loadReportsPersonalDashboard,
  type LoadReportsPersonalDashboardParams,
  type LoadReportsPersonalDashboardResult,
} from './application/loadReportsPersonalDashboard';

export { STOCK_SALE_POLICY_OPTIONS } from './screens/reportsScreen.constants';
export type { DateRangePreset } from './screens/reportsScreen.constants';
export {
  getReportsDateRange,
  getPreviousHomologousPeriod,
  isSalesTimeBandsApplicable,
  formatReportsLoadError,
  formatIntelligenceLoadError,
  type ReportsCustomRange,
} from './screens/reportsScreen.utils';
